import { Trans } from 'react-i18next';

import { Button, Typography } from '@mui/material';

import { ImagePlaceholder } from '@/components/icons/ImagePlaceholder';

import { styles } from './UploadImage.styles';

type TUploadImagePlaceholderProps = {
  select: () => void;
};

export const UploadImagePlaceholder = ({ select }: TUploadImagePlaceholderProps) => {
  return (
    <>
      <ImagePlaceholder sx={styles.imagePlaceholder} />

      <Typography variant="body2" textAlign="center">
        <Trans i18nKey="uploadImage.dragOrUpload">
          <Button variant="text" onClick={select} disableRipple />
          <Typography component="span" variant="caption" color="text.secondary" />
        </Trans>
      </Typography>
    </>
  );
};
